<template>
  <div
    ref="panel"
    :class="classes"
  >
    <div class="panel-header">
      <h2 class="panel-header_title">{{ title }}</h2>

      <button
        class="panel-header_close"
        @click="onHide">
        <icon-close />
      </button>
    </div>

    <div class="panel-content">
      <slot />
      <div class="panel-footer">
        <div class="panel-footer_left">
          <slot name="footer" />
        </div>
        <a
          href="https://simplecast.com"
          target="_blank"
          class="panel-footer_simplecast"
        >
          <simplecast v-if="smallPanel" />
          <simplecast-long v-else />
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import IconClose from '../assets/svg/close.svg'
import Store from '../store'
import SimplecastLong from '../assets/svg/sc-logo-long.svg'
import Simplecast from '../assets/svg/sc-logo.svg'

export default {
  components: {
    IconClose,
    Simplecast,
    SimplecastLong
  },
  props: {
    title: {
      type: String,
      default: null,
      required: true
    },
    onHide: {
      type: Function,
      required: true
    }
  },
  data () {
    return {
      innerHeight: 0,
      innerWidth: 0,
      offsetHeight: 0,
      offsetWidth: 0,
      store: Store,
      urlCopied: false
    }
  },
  computed: {
    smallPanel () {
      return this.offsetWidth < 550
    },
    classes () {
      const panelClasses = ['panel', this.size]

      if (this.isDark) panelClasses.push('dark')
      if (this.offsetWidth < 550) panelClasses.push('panel-small')
      if (this.offsetWidth < 320) panelClasses.push('panel-smallest')
      if (this.offsetWidth < 270) panelClasses.push('hide-icons')
      if (this.offsetHeight < 190) panelClasses.push('panel-thin')
      if (this.offsetHeight < 125) panelClasses.push('panel-tiny')

      return panelClasses
    },
    isDark () { return this.store.state.isDark },
    size () { return this.store.state.size }
  },
  created () {
    window.addEventListener('resize', this.setOffsets)
  },
  beforeDestroy () { window.removeEventListener('resize', this.setOffsets) },
  mounted () {
    this.setOffsets()
  },
  methods: {
    setOffsets () {
      const style = window.getComputedStyle(this.$refs.panel, null)
      const height = parseInt(style.getPropertyValue('height'))
      const padding = parseInt(style.getPropertyValue('padding') || 0)
      const border = parseInt(style.getPropertyValue('border-width'))

      this.innerHeight = height - (padding * 2) - (border * 2)
      this.offsetWidth = this.$refs.panel.offsetWidth + padding
      this.offsetHeight = this.$refs.panel.offsetHeight
    }
  }
}
</script>

<style lang="scss">
@import 'node_modules/simplecast-styles/src/assets/styles/_core/colors.scss';
@import 'node_modules/simplecast-styles/src/assets/styles/_core/fonts.scss';

// .simplecast-playlist .panel {
//   border-color: transparent;
//   padding: 10px 0;
// }

.simplecast-playlist .panel .panel-content {
  height: 150px !important;
}

.simplecast-playlist .main.text-small h2.panel-header_title,
.simplecast-playlist .main.text-extra-small h2.panel-header_title,
.simplecast-playlist .main.text-medium h2.panel-header_title {
  @include font-l-embed(700);
  letter-spacing: 0;
}

.simplecast-playlist .panel {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
}

.panel {
  background: $white-000;
  border: solid 1px $black-trans-200;
  border-radius: 2px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  height: 100%;
  left: 0;
  padding: 20px 16px;
  position: absolute;
  top: 0;
  width: 100%;
  z-index: 100;
  color: $black-trans-800;

  a, svg {
    color: $black-trans-800;
  }

  a:hover, button:hover {
    opacity: .7;
  }
  a:focus, button:focus {
    opacity: .7;
    outline: 0;
  }

  &-content {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    height: calc(100% - 26px);
  }

  &-header {
    display: flex;
    margin-bottom: 20px;
    line-height: 14px;
    align-items: center;
    justify-content: space-between;

    &_title {
      flex: 1;
      margin: 0;
      padding: 0;
      @include font-l-embed(700);
    }

    &_close {
      background: transparent;
      border: none;
      cursor: pointer;
      margin: 0;
      padding: 0;
      text-decoration: underline;
      text-transform: uppercase;
      @include font-m-mono(700);
      svg {
        height: 14px;
        width: 14px;
      }
    }
  }
  &-footer {
    display: flex;
    justify-content: space-between;
    align-items: center;

    &_left {
      line-height: 1;
    }

    &_simplecast {
      color: $black-trans-800;
      line-height: 0;
      svg {
        color: $black-trans-800;
        height: 23px;
        width: 120px;
      }
      &:hover {
        opacity: .7
      }
    }
  }
}

.dark.panel {
  border-color: $white-trans-300;
  background: $black-800;
  color: $white-trans-800;
  a, svg {
    color: $white-trans-800;
  }
  .panel {
    &-header {
      &_close {
        svg {
          fill: $white-trans-800;
        }
      }
    }
    &-footer {
      &_simplecast {
        svg {
          color: $white-trans-800;
        }
      }
    }
  }
}

.panel-small.panel {
  .panel {
    &-content {
      height: calc(100% - 16px);
    }
    &-header {
      margin-bottom: 10px
    }
    &-footer {
      &_simplecast {
        svg {
          width: 23px;
          height: 23px;
        }
      }
    }
  }
}

</style>
